import React from 'react';

import NestedRedirect from 'components/NestedRedirect';

import { extractPrefix } from 'helpers/locales';

const RootPage = () => {
  const prefix = extractPrefix(window.location.pathname);

  return <NestedRedirect to={`${prefix}sign-in`} />;
};

export default RootPage;
